import { render, staticRenderFns } from "./editBanking.vue?vue&type=template&id=c9dc0a20&scoped=true"
import script from "./editBanking.vue?vue&type=script&lang=js"
export * from "./editBanking.vue?vue&type=script&lang=js"
import style0 from "./editBanking.vue?vue&type=style&index=0&id=c9dc0a20&prod&scoped=true&lang=css"
import style1 from "./editBanking.vue?vue&type=style&index=1&id=c9dc0a20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9dc0a20",
  null
  
)

export default component.exports